export const ORDERLY_KEY_PREFIX = 'ed25519';
